module.exports = __webpack_public_path__ + "img/05_speaker5.6b504f04.png";